import { Component, OnInit, ViewEncapsulation, Inject, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { isPlatformServer } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { PaymentService } from '../services/payment.service';
import { BasketService } from '../services/basket.service';
import { LocationService } from '../services/location.service';

import { Cookie } from '../shared/cookie.service';
import { HeaderService } from '../shared/header.service';
import { CurrencyService } from '../shared/currency.service'

import { PaymentData, PaymentDTO } from '../models/payment-data.model';
import { MultiMethodPayer, MultiMethodPaymentDTO, MultiPaymentData } from "../models/multi-payment-data.model";


import { AppSettings } from '../settings/app.settings';
import { EmailValidation } from '../validators/email.validator';
import { CustomSelectValidator } from '../validators/custom-select.validator';
import { CardValidator } from '../validators/card.validator';
import { CustomDatesValidator } from '../validators/custom-date.validator';
import { CustomPayMethodsValidator } from '../validators/payment-methods.validator';
import { AnalyticsUtilsService } from '../shared/analytics-utils.service';
import { isArray } from 'util';


declare var adyen: any; // Declaramos Adyen, se implementa con la importación de JS en el HTML

@Component({
  selector: 'payment',
  styleUrls: ['./payment.component.scss'],
  templateUrl: './payment.component.html',
  encapsulation: ViewEncapsulation.Emulated
})
export class PaymentComponent implements OnInit {
  public transactionError: boolean = false;
  public form: FormGroup;
  public isNode: boolean = true;
  public checked: boolean = true;
  public countries: Object[];
  public data: Object = {};
  public localPayMethods: Object;
  public typePay: boolean = false;
  public hasIssuers: boolean = false;
  public issuers: Object[];
  public issuerId: string;
  public brandCode: string;
  public dataForm: any;
  public hasPlaceholder: boolean = false;
  public placeholderCountryName: string;
  public imgExpress: boolean;
  public imgMaestro: boolean;
  public imgJcb: boolean;
  public imgUnionPay: boolean;
  public imgVPay: boolean;
  public adyenMultiUrl: string = AppSettings.ADYEN_MULTI;
  public items: Object[];
  public errors: string[];
  public total: number;
  public privacyUrl: string;
  public voucherApplied: boolean = false;
  public loading: boolean = false;
  public voucher: string;
  public isSubmited: boolean = false;
  public isAgent: boolean = false;
  public cutoff: any[] = [];
  public months: any[] = [
    { id: 1, name: '01' },
    { id: 2, name: '02' },
    { id: 3, name: '03' },
    { id: 4, name: '04' },
    { id: 5, name: '05' },
    { id: 6, name: '06' },
    { id: 7, name: '07' },
    { id: 8, name: '08' },
    { id: 9, name: '09' },
    { id: 10, name: '10' },
    { id: 11, name: '11' },
    { id: 12, name: '12' }];

  public years: any[] = [
    { id: 2020, name: '2020' },
    { id: 2021, name: '2021' },
    { id: 2022, name: '2022' },
    { id: 2023, name: '2023' },
    { id: 2024, name: '2024' },
    { id: 2025, name: '2025' },
    { id: 2026, name: '2026' },
    { id: 2027, name: '2027' },
    { id: 2028, name: '2028' },
    { id: 2029, name: '2029' },
    { id: 2030, name: '2030' },
    { id: 2031, name: '2031' }];

  constructor(private paymentService: PaymentService, private basketService: BasketService, private translate: TranslateService,
    private cookie: Cookie, public currencyService: CurrencyService, private router: Router, private headerService: HeaderService,
    private route: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object, fb: FormBuilder, private analytics: AnalyticsUtilsService) {
    this.form = fb.group({
      payerData: fb.group({
        payerName: ["", Validators.compose([Validators.required, Validators.max(100), Validators.pattern('^([^0-9]*)$')])],
        payerLastName: ["", Validators.compose([Validators.required, Validators.max(200), Validators.pattern('^([^0-9]*)$')])],
        payerCountry: ["", CustomSelectValidator.required],
        emails: fb.group({
          email: ["", Validators.compose([Validators.required, Validators.max(200), Validators.pattern(/[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])/)])],
          confirmEmail: ["", Validators.compose([Validators.required, Validators.max(200), Validators.pattern(/[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])/)])],
        }, {
          validator: EmailValidation.MatchEmail,
        }),
        travellerName: [""],
        travellerLastName: [""],
        travellerEmails: fb.group({
          email: [""],
          confirmEmail: [""]
        }, {})
      }),
      paymentData: fb.group({
        cardHolderName: ["", [Validators.required, Validators.pattern('^([^0-9]*)$')]],
        cardNumber: ["", [Validators.required, customCardValidator]],
        dates: fb.group({
          cardExpiryMonth: ["", CustomSelectValidator.required],
          cardExpiryYear: ["", CustomSelectValidator.required],
        }, {
          validator: CustomDatesValidator.DateError,
        }),
        cardCvc: ["", [Validators.pattern('^[0-9]{3,4}$')]],
        generationTime: [""],
        withCredit: [""],
        encryptedCard: [""],
        isMethodPay: [""],
        payMethods: fb.group({
          localPayMethod: [""],
          issuer: [""],
        }),
      }, {
        validator: (function (o) {
          if (o.get("withCredit").value == true) {
            o.get("cardHolderName").setErrors(null);
            o.get("cardNumber").setErrors(null);
            o.get("dates").get("cardExpiryMonth").setErrors(null);
            o.get("dates").get("cardExpiryYear").setErrors(null);
            o.get("cardCvc").setErrors(null);
            o.setErrors(null);
            return null;
          } else {
            o.get("cardHolderName").setValidators([Validators.required, Validators.pattern('^([^0-9]*)$')]);
            o.get("cardNumber").setValidators([Validators.required, customCardValidator]);
            o.get("dates").get("cardExpiryMonth").setValidators(CustomSelectValidator.required);
            o.get("dates").get("cardExpiryYear").setValidators(CustomSelectValidator.required);
            o.get("cardCvc").setValidators([Validators.pattern('^[0-9]{3,4}$')]);
          }
        })
      }),
      paymentSummary: fb.group({
        subscribe: [""],
        termsAndCondition: ["", Validators.requiredTrue],
      })
    });
  }

  checkIsChanging() {
    if (!this.checked) {
      this.form.get("payerData").get("travellerName").setValidators(Validators.compose([Validators.required, Validators.max(300), Validators.pattern('^([^0-9]*)$')]));
      this.form.get("payerData").get("travellerLastName").setValidators(Validators.compose([Validators.required, Validators.max(300), Validators.pattern('^([^0-9]*)$')]));
      this.form.get("payerData").get("travellerEmails").get("email").setValidators([
        Validators.required, Validators.max(200),
        Validators.pattern(/[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])/)
      ]);
    } else {
      this.form.get("payerData").get("travellerName").setValidators(null);
      this.form.get("payerData").get("travellerLastName").setValidators(null);
      this.form.get("payerData").get("travellerEmails").setValidators(null);
      this.form.get("payerData").get("travellerEmails").get('email').setValidators(null);
      this.form.get("payerData").get("travellerName").setErrors(null);
      this.form.get("payerData").get("travellerLastName").setErrors(null);
      this.form.get("payerData").get("travellerEmails").setErrors(null);
      this.form.get("payerData").get("travellerEmails").get('email').setErrors(null);
    }
  }

  ngOnInit() {
    this.isAgent = this.cookie.get()['isagent'];
    this.errors = [];
    this.isNode = isPlatformServer(this.platformId);
    this.route.params.subscribe(params => {
      this.initFunction();
    });
    this.currencyService.currencyUpdated.subscribe(currency => {
      if (this.localPayMethods) {
        this.nextStep(1);
        this.getNewPaymentMethods();
      }
      this.initFunction();
    });
    this.route.queryParams.subscribe(params => {
      if (!this.isNode) {
        if (params['CANCELLED'] == "true") {
          this.dataForm = this.cookie.get()['process_data'];
          this.errors.push("PAYMENT_CANCELLED");
          if (this.dataForm) {
            this.dataForm = JSON.parse(this.dataForm);
            this.form.get("payerData").get("payerName").setValue(this.dataForm['payer']['name']);
            this.form.get("payerData").get("payerLastName").setValue(this.dataForm['payer']['lastName']);
            this.form.get("payerData").get("emails").get("email").setValue(this.dataForm['payer']['email']);
            this.form.get("payerData").get("emails").get("confirmEmail").setValue(this.dataForm['payer']['email']);
            if (this.dataForm['clientName'] != (this.dataForm['payer']['name'] + " " + this.dataForm['payer']['lastName'])) {
              this.form.get("payerData").get("travellerName").setValue(this.dataForm['clientName']);
              this.form.get("payerData").get("travellerLastName").setValue(this.dataForm['clientLastName']);
              this.form.get("payerData").get("travellerEmails").get("email").setValue(this.dataForm['clientEmail']);
            }
          }
          this.cookie.remove('process_data');
        } else if (params['REFUSED'] == "true") {
          this.errors.push("PAYMENT_REFUSED");
          this.cookie.remove('process_data');
        } else if (params['PENDING'] == "true") {
          this.cookie.remove('process_data');
          this.cookie.put('process_data_pending', "pending payment");
          this.translate.get("PAYMENT_CONFIRMED_URL").subscribe(url => {
            this.router.navigate([`/${this.translate.currentLang}/${url}`])
          })
        } else if (params['refused'] == "true") {
          this.dataForm = this.cookie.get()['process_data'];
          if (params['refusalReason'] == "CARD_ERROR") {
            this.errors.push("PROBLEMS_CREDIT_CARD")
          }
          else if (params['refusalReason'] == "REFUSED") {
            this.errors.push("PAYMENT_REFUSED")
          } else {
            this.errors.push("OPERATION_NOT_AUTHORISED")
          }
          this.persistData();
        } else if (params['ERROR'] == "true") {
          this.errors.push("TRANSACTION_ERROR");
          this.cookie.remove('process_data');
        }
      }
    });
    this.persistData();
  }

  private persistData() {
    if (this.cookie.get()['process_data'] != null) {
      this.dataForm = this.cookie.get()['process_data'];
      if (this.dataForm) {
        this.dataForm = JSON.parse(this.dataForm);
        this.form.get("payerData").get("payerName").setValue(this.dataForm['payer']['name']);
        this.form.get("payerData").get("payerLastName").setValue(this.dataForm['payer']['lastName']);
        this.form.get("payerData").get("emails").get("email").setValue(this.dataForm['payer']['email']);
        this.form.get("payerData").get("emails").get("confirmEmail").setValue(this.dataForm['payer']['email']);
        if (this.dataForm['clientName'] != (this.dataForm['payer']['name'] + " " + this.dataForm['payer']['lastName'])) {
          this.form.get("payerData").get("travellerName").setValue(this.dataForm['clientName']);
          this.form.get("payerData").get("travellerLastName").setValue(this.dataForm['clientLastName']);
          this.form.get("payerData").get("travellerEmails").get("email").setValue(this.dataForm['clientEmail']);
        }
      }
    }
  }

  initFunction() {
    if (!this.localPayMethods) {
      this.getCountries();
    }
    this.getBasket();
    this.getPrivacyUrl();
  }

  getBasket() {
    return this.basketService.getCurrentBasket().subscribe((basket: any) => {
      if (basket != null) {
        let items = basket.sales;
        this.total = 0;
        this.items = items.map((item) => {
          this.total += item['amount'] * 100; //ADDED
          item['unitsStr'] = item['units'].map(unit => {
            return [unit["pax"], unit['personType']['name']];
          });

          return item;
        });

        this.data['amount'] = this.total / 100;
        this.total = this.total / 100; // Math.ceil((this.total/100)*100)/100; //ADDED /100
        if (this.cookie.get()['voucher'] != null) {

          this.voucher = this.cookie.get()['voucher'];
          if (!this.isNode)
            this.applyCoupon(this.voucher);
        }
      } else {
        this.transactionError = true;
        setTimeout(() => {
          this.translate.get("BASKET_URL").subscribe(url => {
            this.router.navigate([`/${this.translate.currentLang}/${url}`])
          })
        }, 3000);
      }
    }, () => {
      this.errors.push("Basket time expired");
      setTimeout(() => {
        this.translate.get("BASKET_URL").subscribe(url => {
          this.router.navigate([`/${this.translate.currentLang}/${url}`])
        })
      }, 3000);
    });
  }

  getCountries() {
    this.paymentService.getCountries().subscribe(countries => {
      this.countries = countries['countries'];

      this.putCountryInFirstPlace(this.countries, 3);
      this.putCountryInFirstPlace(this.countries, 1);
      this.putCountryInFirstPlace(this.countries, 2);
      this.putCountryInFirstPlace(this.countries, 5);
      this.putCountryInFirstPlace(this.countries, 9);
      this.putCountryInFirstPlace(this.countries, 28);

      this.form.get("paymentData").get("generationTime").setValue(countries['now']);
      if (this.dataForm) {
        let countryID = countries['countries'].filter(c => {
          return this.dataForm['payer']['country']['id'] == c.id;
        })
        this.form.get("payerData").get("payerCountry").setValue(countryID[0]);
        this.placeholderCountryName = countryID[0].name;
        this.hasPlaceholder = true;
        this.cookie.remove('process_data');
      }
    });
  }

  private putCountryInFirstPlace(countryList: any[], countryID: number) {
    let elem = this.countries.find(el => {
      return el["id"] == countryID;
    });
    let index = this.countries.indexOf(elem);
    this.countries.splice(index, 1); //Delete item
    this.countries.unshift(elem); //Stores in first place
  }


  getPaymentMethods(paymentData) {
    this.imgExpress = false;
    this.imgMaestro = false;
    this.imgJcb = false;
    this.imgUnionPay = false;
    this.imgVPay = false;
    this.paymentService.getLocalPaymentMethods(paymentData).subscribe(methods => {
      if (isArray(methods)) {
        this.localPayMethods = methods.filter(method => {
          if (method["brandCode"] == "amex") {
            this.imgExpress = true;
          }
          if (method["brandCode"] == "maestro") {
            this.imgMaestro = true;
          }
          if (method["brandCode"] == "jcb") {
            this.imgJcb = true;
          }
          if (method["brandCode"] == "cup") {
            this.imgUnionPay = true;
          }
          if (method["brandCode"] == "vpay") {
            this.imgVPay = true;
          }
          return method["brandCode"] != "vpay" && method["brandCode"] != "cup" && method["brandCode"] != "jcb" && method["brandCode"] != "maestro" && method["brandCode"] != "amex" && method["brandCode"] != "mc" && method["brandCode"] != "visa";
        });
      }
    }, () => {
      this.errors.push("Basket time expired");
      setTimeout(() => {
        this.translate.get("BASKET_URL").subscribe(url => {
          this.router.navigate([`/${this.translate.currentLang}/${url}`])
        })
      }, 3000);
    });
  }

  paymentAction() {
    this.loading = true;
    this.errors = [];
    this.isSubmited = true;
    this.analytics.click_on_pay();
    if (!this.typePay) {
      CardValidator.Correct(this.form.get("paymentData"));
      if (this.form.valid) {
        let paymentData = new PaymentData(this.form, this.checked);
        this.cookie.put("process_data", JSON.stringify(paymentData));
        if (this.form.get('paymentData').get('encryptedCard').value == true && this.isAgent) {
          paymentData.paymentDTO = new PaymentDTO;
          paymentData.paymentDTO.isCardPayment = false;
          paymentData.paymentDTO.amount = this.total;
        } else {
          paymentData.paymentDTO = new PaymentDTO;
          paymentData.paymentDTO.encryptedForm = this.form.get("paymentData").get("encryptedCard").value;
          paymentData.paymentDTO.amount = this.total;
          paymentData.paymentDTO.coupon = { code: this.voucher };
          paymentData.paymentDTO.userAgent = navigator.userAgent;
        }
        if (this.cookie.get()['__utm__'] != null) {
          paymentData.transactionUtmDTO = JSON.parse(this.cookie.get()['__utm__']);
        }
        this.paymentService.confirmPayment(paymentData).subscribe(paymentResponse => {
          if (paymentResponse['is3DSecure']) {
            this.confirmPayment3dSecure(paymentResponse);
          } else {
            if (paymentResponse['authorised']) {
              if (this.form.get("paymentData").get("withCredit").value) {
                this.headerService.setAgentCredit(this.headerService.agentCredit - this.total);
                this.cookie.put("agent_credit", (this.headerService.agentCredit - this.total).toString());
              }
              this.translate.get("PAYMENT_CONFIRMED_URL").subscribe(url => {
                this.router.navigate([`/${this.translate.currentLang}/${url}`])
              })
            } else if (paymentResponse['errorMessage'] && paymentResponse['errorMessage'].includes("CARD_ERROR")) {
              this.loading = false;
              window.scroll(0, 0);
              this.translate.get("ERROR_CARD_GENERAL").subscribe(message => {
                this.errors.push(message);
              })
              this.nextStep(2);
              this.isSubmited = false;
            } else if (paymentResponse['errorMessage'] && paymentResponse['errorMessage'].includes("SESSION_EXPIRED")) {
              this.errors.push("Basket time expired");
              setTimeout(() => {
                this.translate.get("BASKET_URL").subscribe(url => {
                  this.router.navigate([`/${this.translate.currentLang}/${url}`])
                })
              }, 3000);
            } else {
              this.loading = false;
              window.scroll(0, 0);
              let cutoff = [];
              this.errors.push("OPERATION_NOT_AUTHORISED");
              if (paymentResponse['errorMessage']) {
                paymentResponse['errorMessage'].map(e => {
                  cutoff = paymentResponse['salesCutoffError'];
                });
              }
              if (cutoff) {
                this.translate.get("CUTOFF_ERROR2").subscribe(message => {
                  cutoff.map(c => {
                    let product = this.items.find(i => {
                      return i['id'] == c.id;
                    });
                    this.translate.get(AppSettings.durationType[c.durationType]).subscribe(durationType => {
                      c.name = product['product'] + " - " + product["productOption"];
                      message = message.replace('{{name}}', c.name);
                      message = message.replace('{{duration}}', c.duration);
                      message = message.replace('{{durationType}}', durationType);
                      this.cutoff.push(message);
                    });
                  });
                });
              }
              this.isSubmited = false;
            }
          }
        },
          err => {
            this.errors.push("INTERNAL_SERVER_ERROR");
            this.loading = false;
            this.isSubmited = false;
          });
      } else {
        this.isSubmited = false;
      }
    } else if (this.typePay) {
      if (this.form.valid) {
        let multiPaymentData = new MultiPaymentData(this.form, this.checked);
        multiPaymentData.paymentDTO = new MultiMethodPaymentDTO;
        multiPaymentData.paymentDTO.coupon = { code: this.voucher };
        multiPaymentData.paymentDTO.amount = this.total;
        multiPaymentData.brandCode = this.brandCode;
        if (this.hasIssuers) {
          multiPaymentData.issuerId = this.issuerId;
        }
        let locale = navigator.language || '';
        multiPaymentData.languageTextLocale = locale.replace('-', '_');
        if (this.cookie.get()['__utm__'] != null) {
          multiPaymentData.transactionUtmDTO = JSON.parse(this.cookie.get()['__utm__']);
        }
        this.cookie.put("process_data", JSON.stringify(multiPaymentData));
        this.paymentService.localPayment(multiPaymentData).subscribe(paymentResponse => {
          this.confirmLocalPayment(paymentResponse);
        },
          err => {
            this.errors.push("INTERNAL_SERVER_ERROR");
            this.isSubmited = false;
          });
      }
    }
  }

  private confirmLocalPayment(paymentResponse: Object) {
    if (!this.isNode) {
      document.getElementById("resURL")['value'] = paymentResponse['localPaymentFormData']['resURL'];
      document.getElementById("sessionValidity")['value'] = paymentResponse['localPaymentFormData']['sessionValidity'];
      document.getElementById("merchantReturnData")['value'] = paymentResponse['localPaymentFormData']['merchantReturnData'];
      document.getElementById("shopperLocale")['value'] = paymentResponse['localPaymentFormData']['shopperLocale'];
      document.getElementById("paymentAmount")['value'] = paymentResponse['localPaymentFormData']['paymentAmount'];
      document.getElementById("shipBeforeDate")['value'] = paymentResponse['localPaymentFormData']['shipBeforeDate'];
      document.getElementById("merchantSig")['value'] = paymentResponse['localPaymentFormData']['merchantSig'];
      if (this.hasIssuers) {
        document.getElementById("issuerId")['value'] = paymentResponse['localPaymentFormData']['issuerId'];
      }
      document.getElementById("merchantAccount")['value'] = paymentResponse['localPaymentFormData']['merchantAccount'];
      document.getElementById("countryCode")['value'] = paymentResponse['localPaymentFormData']['countryCode'];
      document.getElementById("skinCode")['value'] = paymentResponse['localPaymentFormData']['skinCode'];
      document.getElementById("shopperEmail")['value'] = paymentResponse['localPaymentFormData']['shopperEmail'];
      document.getElementById("currencyCode")['value'] = paymentResponse['localPaymentFormData']['currencyCode'];
      document.getElementById("merchantReference")['value'] = paymentResponse['localPaymentFormData']['merchantReference'];
      document.getElementById("brandCode")['value'] = paymentResponse['localPaymentFormData']['brandCode'];
      document.getElementById('adyenForm')['submit']();
    }
  }

  private confirmPayment3dSecure(paymentResponse: Object) {
    if (!this.isNode) {
      document.getElementById("PaReq")['value'] = paymentResponse['paRequest'];
      document.getElementById("MD")['value'] = paymentResponse['md'];
      document.getElementById("TermUrl")['value'] = paymentResponse['verifyUrl'];
      document.getElementById("3dform")['action'] = paymentResponse['issuerUrl'];
      document.getElementById('3dform')['submit']();
    }
  }

  applyCoupon(code: string) {
    let _itemsId = this.items.map(item => {
      return { id: item['id'] };
    });
    this.basketService.useCoupon(code, _itemsId).subscribe(message => {
      if (message['errorMessage'] == null) {
        this.cookie.put('voucher', code);
        this.voucherApplied = true;
        this.items = this.items.map(item => {
          let saleFromServer = message['listSaleDTO'].find(function (e) {
            return e['id'] == item['id'];
          });
          if (saleFromServer != null) {
            item['voucherApplied'] = true;
            item['amountDiscount'] = saleFromServer['amount'];
          }
          return item;
        });

        let total = 0;
        this.items.map(item => {
          if (!item['voucherApplied']) {
            total += item['amount'] * 100; //ADDED * 100
          } else {
            total += item['amountDiscount'] * 100; //ADDED * 100
          }
        });
        total = total / 100; //Math.ceil((total/100)*100)/100;

        this.total = total;
      } else {
      }
    });
  }


  getUrl(url: string) {
    return `${AppSettings.CSS_CE_IMAGES}${url}`
  }

  getPrivacyUrl() {
    this.translate.get("PRIVACY_URL").subscribe(text => {
      this.privacyUrl = `/${this.translate.currentLang}/${text}`;
    })
  }

  private getNewPaymentMethods() {
    this.typePay = this.typePay || false;
    this.hasIssuers = false;
    this.form.get('paymentData').get('payMethods').get('issuer').setValue(null);
    this.data['countryId'] = this.form.get("payerData").get("payerCountry").value.id;
    this.getPaymentMethods(this.data);
  }

  public currentStep: number = 1;
  private validateByStep = {
    1: (function () {
      this.typePay = false;
      this.hasIssuers = false;
      if (this.data['countryId'] != this.form.get("payerData").get("payerCountry").value.id) {
        this.getNewPaymentMethods();
      }
      return this.form.get('payerData').valid;
    }).bind(this),
    2: (function (withCredit: boolean) {
      if (!this.typePay) {
        CardValidator.Correct(this.form.get('paymentData'));
      } else if (this.typePay) {
        CustomPayMethodsValidator.PayMethodCorrect(this.form.get('paymentData'));
        if (this.hasIssuers) {
          this.issuerId = this.form.get('paymentData').get('payMethods').get('issuer').value.issuerId;
        }
      }
      return this.form.get('paymentData').valid;
    }).bind(this),
    3: (function () {
      this.typePay = false;
      this.hasIssuers = false;
      return true;
    }).bind(this)
  }

  nextStep(nextStep: number) {
    document.getElementById(`s${this.currentStep}`).classList.remove('correct', 'error');
    if (this.validateByStep[this.currentStep]()) {
      document.getElementById(`s${this.currentStep}`).classList.add('correct');
      document.getElementById(`s${this.currentStep}`).classList.remove('active');
      this.currentStep = nextStep > 3 ? 3 : nextStep;
      document.getElementById(`s${this.currentStep}`).classList.add('active');
      this.analytics.go_step(this.currentStep);
    } else {
      document.getElementById(`s${this.currentStep}`).classList.add('error');
      if (nextStep < this.currentStep) {
        document.getElementById(`s${this.currentStep}`).classList.remove('active');
        this.currentStep = nextStep;
        this.nextStep(nextStep);
      }

    }
  }

  selectCreditCard() {
    this.typePay = false;
    this.hasIssuers = false;
    this.form.get("paymentData").get("payMethods").get('issuer').setValidators(null);
    this.form.get("paymentData").get("payMethods").get('issuer').setErrors(null);
    CustomPayMethodsValidator.CreditCardCorrect(this.form.get('paymentData'));
  }

  selectedIssuers(paymentMethod) {
    this.typePay = true;
    CustomPayMethodsValidator.PayMethodCorrect(this.form.get('paymentData'));
    this.issuers = [];
    this.brandCode = paymentMethod.brandCode;
    if (paymentMethod['issuers']) {
      this.hasIssuers = true;
      this.issuers = paymentMethod['issuers'];
      this.form.get("paymentData").get("payMethods").get('issuer').setValidators(Validators.required);
    } else {
      this.form.get("paymentData").get("payMethods").get('issuer').setValidators(null);
      this.form.get("paymentData").get("payMethods").get('issuer').setErrors(null);
      this.hasIssuers = false;
    }
  }

  public valuechanged(ev) {
    //Removes white spaces 
    if (this.form.get("paymentData").get("cardNumber").value != null) {
      let newVal = this.form.get('paymentData').get("cardNumber").value.toString().replace(/\s/g, '');
      newVal = newVal.replace(/-/g, '');
      this.form.get('paymentData').patchValue({
        cardNumber: newVal
      });
    }
  }
}

import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';



export function customCardValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value) {
    let val = control.value.replace(/\s/g, '');
    val = val.replace(/-/g, '');
    if (isNaN(Number(val))) {
      return { "notANumber": true };
    }
  }

  return null;
}
